import script from "./ChatSideMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatSideMenu.vue?vue&type=script&setup=true&lang=js"

import "./ChatSideMenu.vue?vue&type=style&index=0&id=f07a5bfa&lang=scss"

const __exports__ = script;

export default __exports__